<template>
  <LoadingContent v-if="isPending" />
  <div class="sessions-list" v-else-if="cycles.length">
    <ReminderCard v-for="cycle in cycles" :key="cycle.id" :cycle="cycle" />
  </div>
</template>

<script setup lang="ts">
import ReminderCard from '@/features/admin/reminders/components/reminder-card/reminder-card.vue'
import type { V2CycleType } from '@/features/admin/reminders/types'
import LoadingContent from '@/features/ui/components/loading-content/loading-content.vue'

defineProps<{
  cycles: V2CycleType[]
  isPending: boolean
}>()
</script>

<style lang="scss">
@import './cycles-list.scss';
</style>
